import L from 'leaflet';

/**
 * Name of the dedicated Leaflet pane that hosts every ICAS overlay. Created
 * lazily on the map the first time a layer is rendered. Z-index 350 sits
 * below the default `overlayPane` (400) where parcel polygons live, and
 * well below `markerPane` (600) where photo markers live — so user data
 * always wins click priority, regardless of attach order.
 *
 * Without an explicit pane, Leaflet stacks layers in attach order: toggling
 * the ICAS checkbox AFTER parcels mount would put ICAS on top and swallow
 * clicks meant for parcels / photos. With the pane, the stacking is
 * deterministic and survives any user-driven toggle order.
 */
export const ICAS_PANE = 'icasPane';

/**
 * Ensure the ICAS pane exists on the given Leaflet map. Idempotent —
 * `map.createPane()` is a no-op if a pane with the same name is already
 * registered, but `map.getPane()` returning undefined means we still need
 * to create it. Returns the pane so callers can keep going.
 */
export function ensureIcasPane(map: L.Map): HTMLElement {
  const existing = map.getPane(ICAS_PANE);
  if (existing) return existing;
  const pane = map.createPane(ICAS_PANE);
  pane.style.zIndex = '350';
  // Pointer events stay enabled so clicks (popups) work; we just want
  // user-data panes painted on top.
  return pane;
}
